import React from "react";
import AdminHomeDashboardView from "../../../features/admin-home-dashboard/AdminHomeDashboardView";

const HIDAdminHome = () => {
  return <AdminHomeDashboardView />;
};

export default HIDAdminHome;
